import React from "react";
import styles from "./intelegancePayerSpeedItemControl.module.scss";

const IntelegancePayerSpeedItemControl = (props) => {
  return (
    <div
      className={styles.payerSpeedItemControl}
      onClick={() => {
        props.handleClick(props.speedDevider);
      }}
    >
      x{props.value}
    </div>
  );
};

export default React.memo(IntelegancePayerSpeedItemControl);
